
import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook } from 'lucide-react';
import LogoProcessor from './LogoProcessor';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  // Custom TikTok icon component
  const TikTokIcon = ({ size = 20 }: { size?: number }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
    </svg>
  );
  
  return (
    <footer className="border-t bg-white">
      <div className="mx-auto max-w-7xl px-4 py-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-6 text-sm">
        <div>
          <div className="flex items-center gap-2">
            <LogoProcessor />
          </div>
          <p className="mt-3 text-slate-600">Tools for caregivers to track expenses, stay organized, and find savings.</p>
        </div>
        <div>
          <p className="font-medium">Product</p>
          <ul className="mt-2 space-y-1 text-slate-600">
            <li><Link to="/about" className="hover:text-slate-900">About</Link></li>
            <li><a href="/#features" className="hover:text-slate-900">Features</a></li>
            <li><a href="/#how" className="hover:text-slate-900">How it works</a></li>
            <li><a href="/#faq" className="hover:text-slate-900">FAQ</a></li>
            <li><Link to="/events" className="hover:text-slate-900">Events</Link></li>
            <li><a href="/#affiliations" className="hover:text-slate-900">Affiliations</a></li>
            <li><a href="/#data-control" className="hover:text-slate-900">Your data, your control</a></li>
          </ul>
        </div>
        <div>
          <p className="font-medium">Legal</p>
          <ul className="mt-2 space-y-1 text-slate-600">
            <li><Link to="/privacy-policy" className="hover:text-slate-900">Privacy</Link></li>
            <li><Link to="/terms-and-conditions" className="hover:text-slate-900">Terms</Link></li>
            <li><Link to="/contact" className="hover:text-slate-900">Contact</Link></li>
          </ul>
          <address className="mt-3 not-italic text-slate-600">
            CountedCare, Inc.<br />
            1301 N Broadway STE 32274<br />
            Los Angeles, CA 90012<br />
            <a href="mailto:info@countedcare.com" className="hover:text-slate-900 underline">info@countedcare.com</a>
          </address>
        </div>
        <div>
          <p className="font-medium">Connect</p>
          <div className="mt-2 flex space-x-4">
            <a href="https://www.tiktok.com/@countedcare" target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-slate-900 transition-colors">
              <TikTokIcon size={20} />
              <span className="sr-only">TikTok</span>
            </a>
            <a href="https://www.instagram.com/countedcare/" target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-slate-900 transition-colors">
              <Instagram size={20} />
              <span className="sr-only">Instagram</span>
            </a>
            <a href="https://m.facebook.com/p/CountedCare-61577306866882/" target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-slate-900 transition-colors">
              <Facebook size={20} />
              <span className="sr-only">Facebook</span>
            </a>
          </div>
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-4 pb-10 text-xs text-slate-500 space-y-2">
        <p>CountedCare provides educational tools and is not a tax advisor, accountant, or law firm. Consult a qualified professional for personalized advice.</p>
        <p>© {currentYear} CountedCare, Inc. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
